/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { doctoresPacientesControllerActualizarPaciente } from '../fn/doctor-pacientes/doctores-pacientes-controller-actualizar-paciente';
import { DoctoresPacientesControllerActualizarPaciente$Params } from '../fn/doctor-pacientes/doctores-pacientes-controller-actualizar-paciente';
import { doctoresPacientesControllerAltaPaciente } from '../fn/doctor-pacientes/doctores-pacientes-controller-alta-paciente';
import { DoctoresPacientesControllerAltaPaciente$Params } from '../fn/doctor-pacientes/doctores-pacientes-controller-alta-paciente';
import { doctoresPacientesControllerBorrarPaciente } from '../fn/doctor-pacientes/doctores-pacientes-controller-borrar-paciente';
import { DoctoresPacientesControllerBorrarPaciente$Params } from '../fn/doctor-pacientes/doctores-pacientes-controller-borrar-paciente';
import { doctoresPacientesControllerListadoPacientes } from '../fn/doctor-pacientes/doctores-pacientes-controller-listado-pacientes';
import { DoctoresPacientesControllerListadoPacientes$Params } from '../fn/doctor-pacientes/doctores-pacientes-controller-listado-pacientes';
import { doctoresPacientesControllerObtenerInfoPaciente } from '../fn/doctor-pacientes/doctores-pacientes-controller-obtener-info-paciente';
import { DoctoresPacientesControllerObtenerInfoPaciente$Params } from '../fn/doctor-pacientes/doctores-pacientes-controller-obtener-info-paciente';
import { ListadoPacientesModelDto } from '../models/listado-pacientes-model-dto';
import { UsuarioDto } from '../models/usuario-dto';

@Injectable({ providedIn: 'root' })
export class DoctorPacientesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `doctoresPacientesControllerAltaPaciente()` */
  static readonly DoctoresPacientesControllerAltaPacientePath = '/api/doctor-pacientes/alta-paciente';

  /**
   * Alta de paciente.
   *
   * Crea un nuevo paciente en el sistema. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctoresPacientesControllerAltaPaciente()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctoresPacientesControllerAltaPaciente$Response(params: DoctoresPacientesControllerAltaPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctoresPacientesControllerAltaPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Alta de paciente.
   *
   * Crea un nuevo paciente en el sistema. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctoresPacientesControllerAltaPaciente$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctoresPacientesControllerAltaPaciente(params: DoctoresPacientesControllerAltaPaciente$Params, context?: HttpContext): Observable<void> {
    return this.doctoresPacientesControllerAltaPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctoresPacientesControllerListadoPacientes()` */
  static readonly DoctoresPacientesControllerListadoPacientesPath = '/api/doctor-pacientes/listado-pacientes';

  /**
   * Listado de pacientes.
   *
   * Obtiene un listado de pacientes. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctoresPacientesControllerListadoPacientes()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctoresPacientesControllerListadoPacientes$Response(params?: DoctoresPacientesControllerListadoPacientes$Params, context?: HttpContext): Observable<StrictHttpResponse<ListadoPacientesModelDto>> {
    return doctoresPacientesControllerListadoPacientes(this.http, this.rootUrl, params, context);
  }

  /**
   * Listado de pacientes.
   *
   * Obtiene un listado de pacientes. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctoresPacientesControllerListadoPacientes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctoresPacientesControllerListadoPacientes(params?: DoctoresPacientesControllerListadoPacientes$Params, context?: HttpContext): Observable<ListadoPacientesModelDto> {
    return this.doctoresPacientesControllerListadoPacientes$Response(params, context).pipe(
      map((r: StrictHttpResponse<ListadoPacientesModelDto>): ListadoPacientesModelDto => r.body)
    );
  }

  /** Path part for operation `doctoresPacientesControllerObtenerInfoPaciente()` */
  static readonly DoctoresPacientesControllerObtenerInfoPacientePath = '/api/doctor-pacientes/info-paciente/{uuidPaciente}';

  /**
   * Listado de pacientes.
   *
   * Obtiene un listado de pacientes. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctoresPacientesControllerObtenerInfoPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctoresPacientesControllerObtenerInfoPaciente$Response(params: DoctoresPacientesControllerObtenerInfoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<UsuarioDto>> {
    return doctoresPacientesControllerObtenerInfoPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Listado de pacientes.
   *
   * Obtiene un listado de pacientes. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctoresPacientesControllerObtenerInfoPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctoresPacientesControllerObtenerInfoPaciente(params: DoctoresPacientesControllerObtenerInfoPaciente$Params, context?: HttpContext): Observable<UsuarioDto> {
    return this.doctoresPacientesControllerObtenerInfoPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsuarioDto>): UsuarioDto => r.body)
    );
  }

  /** Path part for operation `doctoresPacientesControllerBorrarPaciente()` */
  static readonly DoctoresPacientesControllerBorrarPacientePath = '/api/doctor-pacientes/borrar-paciente/{uuidPaciente}';

  /**
   * Borrar paciente.
   *
   * Borra un paciente del sistema. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctoresPacientesControllerBorrarPaciente()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctoresPacientesControllerBorrarPaciente$Response(params: DoctoresPacientesControllerBorrarPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctoresPacientesControllerBorrarPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Borrar paciente.
   *
   * Borra un paciente del sistema. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctoresPacientesControllerBorrarPaciente$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  doctoresPacientesControllerBorrarPaciente(params: DoctoresPacientesControllerBorrarPaciente$Params, context?: HttpContext): Observable<void> {
    return this.doctoresPacientesControllerBorrarPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `doctoresPacientesControllerActualizarPaciente()` */
  static readonly DoctoresPacientesControllerActualizarPacientePath = '/api/doctor-pacientes/actualizar-paciente/{uuidPaciente}';

  /**
   * Actualizar paciente.
   *
   * Actualiza un paciente en el sistema. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `doctoresPacientesControllerActualizarPaciente()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctoresPacientesControllerActualizarPaciente$Response(params: DoctoresPacientesControllerActualizarPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return doctoresPacientesControllerActualizarPaciente(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar paciente.
   *
   * Actualiza un paciente en el sistema. Requiere que el usuario tenga el rol de DOCTOR.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `doctoresPacientesControllerActualizarPaciente$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  doctoresPacientesControllerActualizarPaciente(params: DoctoresPacientesControllerActualizarPaciente$Params, context?: HttpContext): Observable<void> {
    return this.doctoresPacientesControllerActualizarPaciente$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
